import React, { useState } from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import { FiPackage, FiFileText, FiPrinter, FiLogOut, FiLock } from 'react-icons/fi';
import AdminProducts from './AdminProducts';
import AdminInvoice from './AdminInvoice';
import AdminReceipt from './AdminReceipt';
import './Admin.css';

const ADMIN_PASSWORD = 'shammy@admin';
const AUTH_KEY = 'shammy_admin_auth';

const AdminLogin = ({ onLogin }) => {
  const [pw, setPw] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pw === ADMIN_PASSWORD) {
      localStorage.setItem(AUTH_KEY, '1');
      onLogin();
    } else {
      setError('Incorrect password. Try again.');
      setPw('');
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-card">
        <img src="/logo.png" alt="Shammy Spices" className="admin-login-logo" />
        <h1 className="admin-login-title">Admin Panel</h1>
        <p className="admin-login-sub">Shammy Spices Management</p>
        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="admin-input-wrap">
            <FiLock className="admin-input-icon" />
            <input
              type="password"
              placeholder="Enter admin password"
              value={pw}
              onChange={(e) => { setPw(e.target.value); setError(''); }}
              className="admin-input"
              autoFocus
            />
          </div>
          {error && <p className="admin-login-error">{error}</p>}
          <button type="submit" className="admin-login-btn">Sign In</button>
        </form>
      </div>
    </div>
  );
};

const AdminLayout = ({ onLogout }) => (
  <div className="admin-shell">
    <header className="admin-header">
      <div className="admin-header-inner">
        <img src="/logo.png" alt="Shammy Spices" className="admin-header-logo" />
        <span className="admin-header-title">Admin</span>
        <button className="admin-logout-btn" onClick={onLogout} aria-label="Logout"><FiLogOut /></button>
      </div>
    </header>

    <main className="admin-main">
      <Routes>
        <Route index element={<AdminProducts />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="invoice" element={<AdminInvoice />} />
        <Route path="receipt" element={<AdminReceipt />} />
      </Routes>
    </main>

    <nav className="admin-bottom-nav">
      <NavLink to="/admin/products" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
        <FiPackage /><span>Products</span>
      </NavLink>
      <NavLink to="/admin/invoice" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
        <FiFileText /><span>Invoice</span>
      </NavLink>
      <NavLink to="/admin/receipt" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
        <FiPrinter /><span>Receipt</span>
      </NavLink>
    </nav>
  </div>
);

const AdminApp = () => {
  const [authed, setAuthed] = useState(() => localStorage.getItem(AUTH_KEY) === '1');
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem(AUTH_KEY);
    setAuthed(false);
    navigate('/admin');
  };

  if (!authed) return <AdminLogin onLogin={() => setAuthed(true)} />;
  return <AdminLayout onLogout={handleLogout} />;
};

export default AdminApp;
